import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ActiveAccountProvider } from "@/contexts/ActiveAccountContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import TrendsPage from "@/pages/Trends";
import ProductsPage from "@/pages/Products";
import GeneratePage from "@/pages/Generate";
import LibraryPage from "@/pages/Library";
import LinksPage from "@/pages/Links";
import AnalyticsPage from "@/pages/Analytics";
import SettingsPage from "@/pages/Settings";
import SchedulerPage from "@/pages/Scheduler";
import MarketplacePage from "@/pages/Marketplace";
import PublicStorefront from "@/pages/PublicStorefront";
import PrivacyPage from "@/pages/Privacy";
import TermsPage from "@/pages/Terms";
import DashboardPage from "@/pages/Dashboard";
import InboxPage from "@/pages/Inbox";
import ReviewReadinessPage from "@/pages/ReviewReadiness";
import MagicLogin from "@/pages/MagicLogin";

function App() {
  return (
    <div className="App min-h-screen bg-zinc-950 text-zinc-100">
      <AuthProvider>
        <ActiveAccountProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth/magic" element={<MagicLogin />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/app" element={<Layout />}>
                  <Route index element={<Navigate to="/app/dashboard" replace />} />
                  <Route path="dashboard" element={<DashboardPage />} />
                  <Route path="trends" element={<TrendsPage />} />
                  <Route path="products" element={<ProductsPage />} />
                  <Route path="generate" element={<GeneratePage />} />
                  <Route path="library" element={<LibraryPage />} />
                  <Route path="links" element={<LinksPage />} />
                  <Route path="analytics" element={<AnalyticsPage />} />
                  <Route path="scheduler" element={<SchedulerPage />} />
                  <Route path="settings" element={<SettingsPage />} />
                  <Route path="settings/review-readiness" element={<ReviewReadinessPage />} />
                  <Route path="marketplace" element={<MarketplacePage />} />
                  <Route path="inbox" element={<InboxPage />} />
                </Route>
              </Route>
              <Route path="/store/:handle" element={<PublicStorefront />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/" element={<Navigate to="/app/products" replace />} />
              <Route path="*" element={<Navigate to="/app/products" replace />} />
            </Routes>
          </BrowserRouter>
        </ActiveAccountProvider>
        <Toaster theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
